import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';
import { bouncy } from 'ldrs';
import { CSSTransition } from 'react-transition-group';

const Contact = ({ isDarkMode }) => {
    bouncy.register();

    const [messages, setMessages] = useState([]);
    const [showLoading, setShowLoading] = useState(true); // Loader visibility
    const [showMessage, setShowMessage] = useState(false); // Message visibility

    // Effect to transition the loader out
    useEffect(() => {
        const loaderTimeout = setTimeout(() => {
            setShowLoading(false); // Begin fading out the loader
        }, 4000); // Loader duration

        return () => clearTimeout(loaderTimeout); // Cleanup timeout if component unmounts
    }, []);

    // Effect to delay the message appearance until loader fades out
    useEffect(() => {
        if (!showLoading) {
            const messageTimeout = setTimeout(() => {
                setShowMessage(true); // Show the message after loader finishes
            }, 300); // Match the CSS transition duration for fading out the loader

            return () => clearTimeout(messageTimeout); // Cleanup timeout
        }
    }, [showLoading]);

    const handleSubmit = (e) => {
        e.preventDefault();

        // Submit form directly to Fabform.io endpoint
        const form = e.target;

        fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            mode: 'no-cors', // Add this line
        })
            .then(() => {
                setMessages((prevMessages) => [
                    ...prevMessages,
                    {
                        id: Date.now(),
                        text: 'Message Sent!',
                    },
                ]);

                form.reset(); // Reset form fields
            })
            .catch((err) => console.error('Error:', err));
    };

    const leftMessage = () => (
        <div className={`message-left ${isDarkMode ? 'message-left-dark' : 'message-left-light'}`}>
            <p>
                Hey there! 😊 Thanks for visiting my portfolio! <br /> <br />
                If you have any questions or want to chat, feel free to
                drop me a message here! I’ll get back to you as soon as
                I can. <br /> <br />
                Looking forward to hearing from you!
            </p>
        </div>
    );

    const leftLoading = () => (
        <div className={`message-left message-loading ${isDarkMode ? 'message-left-dark' : 'message-left-light'}`}>
            <l-bouncy
                size="18"
                speed="1.75"
                color={isDarkMode ? "white" : "black"}
            ></l-bouncy>
        </div>
    );

    return (
        <div className="contact-form-container">
            <div className={`contact-header ${isDarkMode ? 'contact-header-dark' : 'contact-header-light'}`}>
                To: Celina Shen
            </div>
            <div className="message-container">
                <div className="message-container-left">
                    <div className="message-user-icon">🐻‍❄️</div>
                    <CSSTransition
                        in={showLoading}
                        timeout={300}
                        classNames="fade"
                        unmountOnExit
                    >
                        {leftLoading()}
                    </CSSTransition>
                    <CSSTransition
                        in={showMessage}
                        timeout={300}
                        classNames="fade"
                        unmountOnExit
                    >
                        {leftMessage()}
                    </CSSTransition>
                </div>

                {messages.map((message) => (
                    <div key={message.id} className="message-container-right">
                        <div className={`message-right ${isDarkMode ? 'message-right-dark' : 'message-right-light'}`}>{message.text}</div>
                        <div className="message-user-icon">🧸</div>
                    </div>
                ))}
            </div>
            

            <form
                action="https://formspree.io/f/xyzybqjd"
                method="post"
                onSubmit={handleSubmit}
                className="contact-form"
            >
                <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Your Name"
                    className={`form-input input-top ${isDarkMode ? 'form-input-dark' : 'form-input-light'}`}
                    required
                />
                <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Your Email"
                    className={`form-input input-mid ${isDarkMode ? 'form-input-dark' : 'form-input-light'}`}
                    required
                />
                <textarea
                    name="message"
                    id="message"
                    placeholder="Message"
                    className={`form-input input-bot ${isDarkMode ? 'form-input-dark' : 'form-input-light'}`}
                    rows="3"
                    required
                />
                <button type="submit" className={`form-submit ${isDarkMode ? 'form-submit-dark' : 'form-submit-light'}`}>
                    Send
                </button>
            </form>
        </div>
    );
};

export default Contact;
